import Controller from "./Controller.js";
import { initObjectVideo, destroyObjectVideo } from './../shared/object-media'

class ObjectVideoController extends Controller {
  /**
  * Add event listeners called on <code>onViewShow()</code>
  **/
  addEventListeners() {
    super.addEventListeners();
    initObjectVideo()
  }
  /**
  * Remove event listeners called on <code>onViewHide()</code>
  **/
  removeEventListeners() {
    super.removeEventListeners();
    destroyObjectVideo()
  }
}
export default ObjectVideoController